import { render, staticRenderFns } from "./PurchaseDemandAdd.vue?vue&type=template&id=362893b4&scoped=true"
import script from "./PurchaseDemandAdd.vue?vue&type=script&lang=js"
export * from "./PurchaseDemandAdd.vue?vue&type=script&lang=js"
import style0 from "./PurchaseDemandAdd.vue?vue&type=style&index=0&id=362893b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362893b4",
  null
  
)

export default component.exports